/* eslint-disable import/no-dynamic-require */
import React from "react"
import { LazyLoadImage } from "react-lazy-load-image-component"
import * as style from "./HeroImage.module.scss"

const HeroImage = ({
  children, type, imageWidth, imageHeight,
}) => (
  <section className={style.heroImage}>
    <div className={style.content}>
      {children}
    </div>
    <div className={style.imageWrapper}>
      {type !== undefined
        && (
        <LazyLoadImage
          className={style.image}
          src={require(`./images/${type}.png`).default}
          alt={`${type} thumbnail`}
          width={imageWidth}
          height={imageHeight}
        />
      )}
    </div>
  </section>
)

export default HeroImage
